import { Box, Grid, Typography } from '@mui/material';
import { useTranslation, Trans } from 'react-i18next';
import ClickableLink from '../../components/Text/ClickableLink';
import PageTitle from '../../components/Text/PageTitle';

function CookiePolicy() {
  const [t] = useTranslation();
  return (
    <Box>
      <PageTitle>{t('translation:pages.cookiePolicy.title')}</PageTitle>
      <Grid container sx={{ paddingTop: '1.5rem', paddingBottom: '2.5rem' }}>
        <Grid item xl={5} md={12} xs={12}>
          <Typography>
            <Trans
              i18nKey="pages.cookiePolicy.message"
              components={{
                br: <br />,
                Link: <ClickableLink to="https://www.vodafone.com/business/privacy/privacy-policy#cookie-policy" />,
              }}
            />
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
}

export default CookiePolicy;
